module.exports = __webpack_public_path__ + "static/fonts/opensans-regular-webfont.a62cef1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/opensans-regular-webfont.woff2
// module id = Drys
// module chunks = 2